import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "loan-details-section-wrapper" }
const _hoisted_2 = {
  class: "loan-details-section",
  ref: "schoolConfirmationRef",
  id: "schoolConfirmation"
}
const _hoisted_3 = { class: "loan-details-section-header" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "loan-details-section-content two-column-grid" }
const _hoisted_6 = {
  class: "info-section",
  id: "school"
}
const _hoisted_7 = { class: "info" }
const _hoisted_8 = {
  class: "info-section",
  id: "graduationDate"
}
const _hoisted_9 = { class: "info" }
const _hoisted_10 = {
  class: "info-section",
  id: "academicTerms"
}
const _hoisted_11 = { class: "info" }
const _hoisted_12 = {
  class: "loan-details-section",
  ref: "loanTermsRef",
  id: "interestRateAndLoanTerms"
}
const _hoisted_13 = { class: "loan-details-section-header" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "loan-details-section-content single-row" }
const _hoisted_16 = {
  class: "info-section",
  id: "maxApprovedAmount"
}
const _hoisted_17 = { class: "info" }
const _hoisted_18 = { class: "loan-details-section-content two-column-grid" }
const _hoisted_19 = {
  class: "info-section",
  id: "loanAmount"
}
const _hoisted_20 = { class: "info" }
const _hoisted_21 = {
  class: "info-section",
  id: "loanAmountPerTerm"
}
const _hoisted_22 = { class: "info" }
const _hoisted_23 = {
  class: "info-section",
  id: "repaymentType"
}
const _hoisted_24 = { class: "info" }
const _hoisted_25 = {
  class: "info-section",
  id: "rateSelection"
}
const _hoisted_26 = { class: "info" }
const _hoisted_27 = {
  key: 0,
  class: "info-section",
  id: "inSchoolPayments"
}
const _hoisted_28 = { class: "info-title" }
const _hoisted_29 = { class: "info" }
const _hoisted_30 = {
  key: 1,
  class: "info-section",
  id: "postGradPayments"
}
const _hoisted_31 = { class: "info-title" }
const _hoisted_32 = { class: "info" }

import { computed } from "vue";
import { useStore } from "vuex";
import { PelLoanConfigurationDetails } from "@/models/pel";
import TooltipComponent from "@/components/shared/TooltipComponent.vue";
import Icon from "@/components/shared/Icon.vue";
import useApplicationData from "@/composables/useApplicationData";


export default /*@__PURE__*/_defineComponent({
  __name: 'LocLoanConfigurationDetailsSection',
  props: {
  loading: { type: Boolean, required: true },
},
  emits: ["complete", "close", "cancel", "openSchoolConfirmationModal", "openLoanOptionsModal", "openLoanConfigurationModal"],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore();

const emit = __emit;

const { isValidProfessionalGradFlow } = useApplicationData();

const locDetails = computed<PelLoanConfigurationDetails>(
  () => store.state.loanConfigurationModule.applicationInfo,
);

const showPaymentEstimates = computed<boolean>(() => isValidProfessionalGradFlow.value);

const loanAmount = computed<string>(
  () => locDetails.value?.loanAmountDisplay || "Not Yet Selected",
);
const loanAmountPerTerm = computed<string>(
  () => locDetails.value?.loanAmountPerTermDisplay || "Not Yet Selected",
);
const schoolName = computed<string>(() => locDetails.value?.schoolName || "Not Yet Selected");
const graduationDate = computed<string>(
  () => locDetails.value?.graduationDateDisplay || "Not Yet Selected",
);
const academicTerms = computed<string>(() => locDetails.value?.academicTerms || "Not Yet Selected");
const schoolUndecided = computed<boolean>(() => locDetails.value?.schoolUndecided);

// Methods
function openSchoolConfirmationModal() {
  emit("openSchoolConfirmationModal", true);
}

function openLoanOptionsModal() {
  emit("openLoanOptionsModal", true);
}

function openLoanConfigurationModal() {
  emit("openLoanConfigurationModal", true);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createTextVNode(" School Confirmation ", -1)),
          _createElementVNode("a", {
            class: "edit-loan-config-link",
            href: "#/",
            onClick: _withModifiers(openSchoolConfirmationModal, ["prevent"]),
            disabled: __props.loading
          }, " Edit ", 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "info-title" }, "School", -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString(schoolName.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "info-title" }, [
              _createTextVNode("Graduation Date"),
              _createElementVNode("span", { class: "error" }, "*")
            ], -1)),
            _createElementVNode("div", _hoisted_9, _toDisplayString(graduationDate.value), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "info-title" }, "Academic Term(s)", -1)),
            _createElementVNode("div", _hoisted_11, _toDisplayString(academicTerms.value), 1)
          ])
        ])
      ], 512)
    ], 512), [
      [_vShow, !__props.loading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _cache[4] || (_cache[4] = _createTextVNode(" Interest Rate & Line of Credit Terms ", -1)),
        _createElementVNode("a", {
          class: "edit-loan-config-link",
          href: "#/",
          onClick: _withModifiers(openLoanConfigurationModal, ["prevent"]),
          disabled: __props.loading
        }, " Edit ", 8, _hoisted_14)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "info-title" }, "Maximum Approved Line of Credit Amount", -1)),
          _createElementVNode("div", _hoisted_17, _toDisplayString(locDetails.value?.maxApprovedAmountDisplay), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", {
            class: _normalizeClass(["info-title", { disabled: schoolUndecided.value }])
          }, [
            _cache[8] || (_cache[8] = _createTextVNode(" Current Requested Amount ", -1)),
            (schoolUndecided.value)
              ? (_openBlock(), _createBlock(TooltipComponent, {
                  key: 0,
                  ref: "loanAmountTooltipRef",
                  class: "xs-bottom-center xs-bottom-center-right-auto"
                }, {
                  toggle: _withCtx(() => [
                    _cache[6] || (_cache[6] = _createTextVNode(" ", -1)),
                    _createVNode(Icon, { icon: "info" })
                  ]),
                  default: _withCtx(() => [
                    _cache[7] || (_cache[7] = _createElementVNode("div", null, " This value cannot be edited until after you provide a school, graduation date, and academic term. ", -1))
                  ]),
                  _: 1
                }, 512))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("p", null, _toDisplayString(loanAmount.value), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "info-title" }, "Amount Per Academic Term", -1)),
          _createElementVNode("div", _hoisted_22, _toDisplayString(loanAmountPerTerm.value), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _cache[10] || (_cache[10] = _createElementVNode("p", { class: "info-title" }, [
            _createTextVNode("Repayment Type"),
            _createElementVNode("span", { class: "error" }, "*")
          ], -1)),
          _createElementVNode("div", _hoisted_24, _toDisplayString(locDetails.value?.repaymentTypeDisplay), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[11] || (_cache[11] = _createElementVNode("p", { class: "info-title" }, [
            _createTextVNode("Rate Selection"),
            _createElementVNode("span", { class: "error" }, "*")
          ], -1)),
          _createElementVNode("div", _hoisted_26, _toDisplayString(locDetails.value?.rateSelectionDisplay), 1)
        ]),
        (showPaymentEstimates.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("p", _hoisted_28, _toDisplayString(locDetails.value?.monthlyInSchoolPaymentLabel || "In-School") + " Monthly Est. Payments ", 1),
              _createElementVNode("div", _hoisted_29, _toDisplayString(locDetails.value?.monthlyInSchoolPaymentsDisplay), 1)
            ]))
          : _createCommentVNode("", true),
        (showPaymentEstimates.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("p", _hoisted_31, _toDisplayString(locDetails.value?.monthlyPostSchoolPaymentLabel || "Post-Grad") + " Monthly Est. Payments ", 1),
              _createElementVNode("div", _hoisted_32, _toDisplayString(locDetails.value?.monthlyPostGradPaymentsDisplay), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, !__props.loading]
    ])
  ], 64))
}
}

})